import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Subscription, timer } from 'rxjs';
import { CustomDialogService } from 'src/app/share/services/customDialog.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { AuthService } from 'src/app/share/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutMonitoringService {
  private timerSubscription: Subscription | null = null;

  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    private customDialogService: CustomDialogService,
    private languageService: LanguageService
  ) {}

  init() {
    const startTime = new Date();
    const endTime = new Date(this.storageService.getFromSession<string>('expires'));
    const timeToLogout = endTime.getTime() - 10000 - startTime.getTime(); // 10 sec Puffer
    const timeToRemain = 300000; // 5 min vorher
    const timeToAlert = timeToLogout - timeToRemain;
    const minToRemain = Math.floor(timeToRemain / 60000);

    this.stop();
    this.timerSubscription = timer(timeToAlert).subscribe(() => {
      const title = this.languageService.translate('attention');
      const message = this.languageService.translate('automaticLogout_1') + minToRemain + this.languageService.translate('automaticLogout_2');
      this.customDialogService.showCustomAlert(title, message).show();
    });

    this.timerSubscription = timer(timeToLogout).subscribe(() => {
      this.authService.logout();
      const title = this.languageService.translate('attention');
      const message = this.languageService.translate('automaticLogout');
      this.customDialogService.showCustomAlert(title, message).show();
    });
  }

  stop() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription.closed = true;
      this.timerSubscription.remove(this.timerSubscription);
    }
  }
}
